const TimeoutModalDisplayTextEn = {
    title: 'Are you still there?',
    timeout: (sRemaining) => `Your session is about to timeout in ${sRemaining} seconds.`,
    clickHere: 'Click continue to remain logged in.',
    continue: 'Continue',
};
export default TimeoutModalDisplayTextEn;
